var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.5,
    cy: 53.5,
    r: 53.5,
    fill: "#FCFAF8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.87 53.5v15.695c0 2.32 2.518 3.762 4.518 2.588l26.74-15.696c1.975-1.159 1.975-4.015 0-5.174l-26.74-15.695c-2-1.174-4.519.268-4.519 2.587V53.5Z",
    fill: "#163144"
  })));
};
export default SvgPlayButton;